<div class="role-icons">
  @for (appliRoleIcon of appliRoleIcons; track appliRoleIcon) {
    <div>
      <div
        title="{{appliRoleIcon.appli + ' / ' + appliRoleIcon.role}}">
        @switch (appliRoleIcon.role) {
          @case ('NONE') {
            <aa-icon-circle
              class="grey duotone"
              [faIcon]="appliRoleIcon.icon">
            </aa-icon-circle>
          }
          @case ('READER') {
            <aa-icon-circle
              class="info duotone"
              [faIcon]="appliRoleIcon.icon">
            </aa-icon-circle>
          }
          @case ('USER') {
            <aa-icon-circle
              class="blue duotone"
              [faIcon]="appliRoleIcon.icon">
            </aa-icon-circle>
          }
          @case ('MANAGER') {
            <aa-icon-circle
              class="success duotone"
              [faIcon]="appliRoleIcon.icon">
            </aa-icon-circle>
          }
          @case ('ADMIN') {
            <aa-icon-circle
              class="warning2 duotone"
              [faIcon]="appliRoleIcon.icon">
            </aa-icon-circle>
          }
        }
      </div>
    </div>
  }
</div>
